import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Privacy notice — shown once right after login, then not again until a new login session.
 */
export function PrivacyBanner() {
  const [hidden, setHidden] = useState(true);
  const { user } = useAuth() || {};

  useEffect(() => {
    if (!user) return;
    if (sessionStorage.getItem("aura_privacy_pending") === "1") {
      sessionStorage.removeItem("aura_privacy_pending");
      setHidden(false);
    }
  }, [user]);

  const accept = () => setHidden(true);

  if (hidden) return null;
  return (
    <div
      className="fixed bottom-4 left-4 right-4 lg:left-auto lg:right-6 lg:max-w-sm z-[70] mb-20 lg:mb-6"
      data-testid="privacy-banner"
    >
      <div className="card-lux p-5 shadow-lg">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="eyebrow">Privacy</div>
            <p className="text-sm text-stone-700 mt-2 leading-relaxed">
              We use only essential cookies to keep you signed in and to remember your language.
              No third-party trackers. Read our{" "}
              <Link to="/compliance" className="link-under font-medium">compliance posture</Link>.
            </p>
            <button
              onClick={accept}
              className="btn-primary mt-4 text-sm py-2"
              data-testid="privacy-accept-btn"
            >
              Got it
            </button>
          </div>
          <button
            onClick={accept}
            className="text-stone-400 hover:text-stone-600"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
